<template>
  <div class="height100" @click="closeAnimateList">
    <el-collapse v-if="!activeAnimateSetting && isOnlyNormalRect" v-model="activeNames">
      <el-collapse-item title="滚动到可见时" name="4">
        <animateGroup-set :animateGroup.sync="animateGroup"/>
        <button class="scan-btn" v-if="animateGroup && animateGroup.animateType" @click="scanAnimates('pageload1')">
          <span class="icon icon-play"></span>预览
        </button>
      </el-collapse-item>
    </el-collapse>
    <el-collapse v-if="!onlyShowScrollAnimate && !activeAnimateSetting && isOnlyNormalRect" v-model="activeNames">
      <el-collapse-item title="页面加载时" name="1">
        <template slot="title">
          页面加载时
          <span class="stop-blank" @click.stop></span>
          <div class="add-btn" @click.stop="addAnimateBtn('PageLoad')"><i class="icon icon-portal-plus-small"></i></div>
        </template>
        <pageLoadingAnimate
            v-if="showPageLoadAnimate"
            @addAnimate="addAnimate"
            :targetName="options.innerElement"
            :type="'PageLoad'"
        />
        <div class="empty-animate" v-if="ownPageloadAnimates.length === 0">
          <div>
            <span class="icon icon-portal-page-load"></span>
            <p>点击右上角 + 添加</p>
            <p>或者点击下面常用动画直接使用</p>
          </div>
          <button @click="addDefaultAnimate('pageload', 'fadeIn')">飞入</button>
        </div>
        <!--已经添加的动画列表-->
        <ul v-else class="own-animates">
          <li
            :key="index"
            class="own-animate-item"
            v-for="(animate, index) in ownPageloadAnimates"
            @mouseleave="activePageLoadAnimateIndex = undefined"
          >
            <div class="verticallyCenter animate-item" @click="editAnimate(animate, index, 'PageLoad')">
              <span :class="animate.iconClass + ' mr8'"></span>
              <span class="animate-name">{{ animate.name }}</span>
              <span class="component-name">{{ animate.componentName }}</span>
              <span class="more-handles icon-portal-more" @click.stop="showMoreHandles(index, 'PageLoad')"></span>
            </div>
            <div class="handle-btns" v-if="activePageLoadAnimateIndex === index" @click="animateItemLeave">
              <div class="handle-btn-item verticallyCenter" @click="editAnimate(animate, index, 'PageLoad')">
                <span class="icon icon-portal-edit"></span>编辑
              </div>
              <div class="handle-btn-item verticallyCenter" @click="copyAnimate(animate, index, 'PageLoad')">
                <span class="icon icon-portal-copy"></span>复制
              </div>
              <div class="handle-btn-item verticallyCenter" @click="delAnimate(index, 'PageLoad')">
                <span class="icon icon-portal-delete"></span>删除
              </div>
            </div>
          </li>
        </ul>
        <button class="scan-btn" v-if="pageloadAnimates.length > 0" @click="scanAnimates('pageload')">
          <span class="icon icon-portal-play"></span>预览
        </button>
      </el-collapse-item>
    </el-collapse>
    <el-collapse v-if="!onlyShowScrollAnimate && !activeAnimateSetting && showMouseEvent" v-model="activeNames">
      <el-collapse-item title="鼠标滑过时" name="2">
        <template slot="title">
          鼠标滑过时
          <span class="stop-blank" @click.stop></span>
          <div class="add-btn" @click.stop="addAnimateBtn('Hover')"><i class="icon icon-portal-plus-small"></i></div>
        </template>
        <hoverAnimate
            v-if="showHoverAnimate"
            @addAnimate="addAnimate"
            :targetName="options.innerElement"
            :type="'Hover'"
        />
        <div class="empty-animate" v-if="ownHoverAnimates.length === 0">
          <div>
            <span class="icon icon-portal-hover"></span>
            <p>点击右上角 + 添加</p>
            <p>或者点击下面常用动画直接使用</p>
          </div>
          <button @click="addDefaultAnimate('hover', 'fadeIn')">飞入</button>
        </div>
        <!--已经添加的动画列表-->
        <ul v-else class="own-animates">
          <li
            :key="index"
            class="own-animate-item"
            v-for="(animate, index) in ownHoverAnimates"
            @mouseleave="activeHoverAnimateIndex = undefined"
          >
            <div class="verticallyCenter animate-item" @click="editAnimate(animate, index, 'Hover')">
              <span :class="animate.iconClass + ' mr8'"></span>
              <span class="animate-name">{{ animate.name }}</span>
              <span  class="component-name">{{ animate.componentName }}</span>
              <span class="more-handles icon-portal-more" @click.stop="showMoreHandles(index, 'Hover')"></span>
            </div>
            <div class="handle-btns" v-if="activeHoverAnimateIndex === index" @click="animateItemLeave">
              <div class="handle-btn-item verticallyCenter" @click="editAnimate(animate, index, 'Hover')">
                <span class="icon icon-portal-edit"></span>编辑
              </div>
              <div class="handle-btn-item verticallyCenter" @click="copyAnimate(animate, index, 'Hover')">
                <span class="icon icon-portal-copy"></span>复制
              </div>
              <div class="handle-btn-item verticallyCenter" @click="delAnimate(index, 'Hover')">
                <span class="icon icon-portal-delete"></span>删除
              </div>
            </div>
          </li>
        </ul>
        <button class="scan-btn" v-if="ownHoverAnimates.length > 0" @click="scanAnimates('hover')">
          <span class="icon icon-portal-play"></span>预览
        </button>
      </el-collapse-item>
    </el-collapse>
    <el-collapse v-if="!onlyShowScrollAnimate && !activeAnimateSetting && showMouseEvent" v-model="activeNames">
      <el-collapse-item title="鼠标点击时" name="3">
        <template slot="title">
          鼠标点击时
          <span class="stop-blank" @click.stop></span>
          <div class="add-btn" @click.stop="addAnimateBtn('Click')"><i class="icon icon-portal-plus-small"></i></div>
        </template>
        <clickAnimate
            v-if="showClickAnimate"
            @addAnimate="addAnimate"
            :targetName="options.innerElement"
            :type="'Click'"
        />
        <div class="empty-animate" v-if="ownClickAnimates.length === 0">
          <div>
            <span class="icon icon-portal-click"></span>
            <p>点击右上角 + 添加</p>
            <p>或者点击下面常用动画直接使用</p>
          </div>
          <button @click="addDefaultAnimate('click', 'fadeIn')">飞入</button>
        </div>
        <!--已经添加的动画列表-->
        <ul v-else class="own-animates">
          <li
            :key="index"
            class="own-animate-item"
            v-for="(animate, index) in ownClickAnimates"
            @mouseleave="activeClickAnimateIndex = undefined"
          >
            <div class="verticallyCenter animate-item"  @click="editAnimate(animate, index, 'Click')">
              <span :class="animate.iconClass + ' mr8'"></span>
              <span class="animate-name">{{ animate.name }}</span>
              <span class="component-name">{{ animate.componentName }}</span>
              <span class="more-handles icon-portal-more" @click.stop="showMoreHandles(index, 'Click')"></span>
            </div>
            <div class="handle-btns" v-if="activeClickAnimateIndex === index" @click="animateItemLeave">
              <div class="handle-btn-item verticallyCenter" @click="editAnimate(animate, index, 'Click')">
                <span class="icon icon-portal-edit"></span>编辑
              </div>
              <div class="handle-btn-item verticallyCenter" @click="copyAnimate(animate, index, 'Click')">
                <span class="icon icon-portal-copy"></span>复制
              </div>
              <div class="handle-btn-item verticallyCenter" @click="delAnimate(index, 'Click')">
                <span class="icon icon-portal-delete"></span>删除
              </div>
            </div>
          </li>
        </ul>
        <button class="scan-btn" v-if="ownClickAnimates.length > 0" @click="scanAnimates('click')">
          <span class="icon icon-portal-play"></span>预览
        </button>
        <el-checkbox  v-if="ownClickAnimates.length > 0" v-model="recoverClickAnimateStatu">动画结束后恢复至默认状态</el-checkbox>
      </el-collapse-item>
    </el-collapse>
    <!--动画设置-->
    <div class="height100" v-if="activeAnimateSetting">
      <div class="animate-Setting-header verticallyCenter">
        <span class="flex1 animete-name">{{ activeAnimate.name }}</span>
        <div class="animate-Setting-btns">
          <button class="cancle-btn" @click="cancleAnimateSet">取消</button>
          <button class="primary-btn" @click="saveAnimateSet">保存</button>
        </div>
      </div>
      <div class="animate-setting-main">
        <div class="animate-target verticallyCenter" v-show="showChooseComponent">
          <span class="label mr16">目标</span>
          <div class="flex1 rectTreeWrap" :class="showRectTree?'zIndex9999':''">
            <div class="rect-tree-inp">
              <input
                class="selected-rect"
                type="text"
                readonly
                :value="innerElementLabel"
                @click.stop="showRectTree = !showRectTree"
              />
              <span :class="showRectTree ? 'icon-portal-arrows-down rotate180' : 'icon-portal-arrows-down'"></span>
            </div>
            <chooseComponent
              class="rectTree"
              v-if="showRectTree"
              :isShow="showRectTree"
              :responseRectIds.sync="responseRectIds"
              :innerElementLabel.sync="innerElementLabel"
              :checkedIds="activeAnimate.ids"
              @click.stop
            />
          </div>
        </div>
        <component :is="activeAnimateSetting" :animateData.sync="activeAnimate" :options="options" :responseRectIds = responseRectIds></component>
      </div>
    </div>
  </div>
</template>

<script>
import { idsFilter, objectSize, compareIds } from "utils/event/animate.js"
import chooseComponent from "./animate/chooseComponent"
import pageLoadingAnimate from "./animate/animateList/page-loading-animate"
import hoverAnimate from "./animate/animateList/hover-animate"
import clickAnimate from "./animate/animateList/click-animate"
import moveSetting from "./animate/animate-setting/move"
import rotateScaleSetting from "./animate/animate-setting/rotateScale"
import fadeInSetting from "./animate/animate-setting/fadeIn"
import fontColorSetting from "./animate/animate-setting/fontColor"
import fontSizeSetting from "./animate/animate-setting/fontSize"
import fontWeightSetting from "./animate/animate-setting/fontWeight"
import opacitySetting from "./animate/animate-setting/opacity"
import backgroundSetting from "./animate/animate-setting/background"
import borderSetting from "./animate/animate-setting/border"
import borderRadiusSetting from "./animate/animate-setting/borderRadius"
import boxShadowSetting from "./animate/animate-setting/boxShadow"
import sizeSetting from "./animate/animate-setting/size"
import pageScrollSetting from "./animate/animate-setting/pageScroll"
import imageScaleSetting from "./animate/animate-setting/imageScale"
import iconReplaceSetting from "./animate/animate-setting/iconReplace"
import animateGroupSet from "./animate/animateGroupSet"
import { v1 } from "uuid"
import { handleFindLayoutComponentOptionsCols, hasProperty, isExist, simpleDeepClone } from "../../../utils"
import componentsMixIn from "./animate/animateList/animateStyles.vue"
import { componentNames } from "dependencies/base"
import { CATEGORY_MODE } from "@/consts/index.js"
export default {
  name: "animate-set",
  mixins: [componentsMixIn],
  components: {
    chooseComponent,
    pageLoadingAnimate,
    hoverAnimate,
    clickAnimate,
    moveSetting,
    rotateScaleSetting,
    fadeInSetting,
    fontColorSetting,
    fontSizeSetting,
    fontWeightSetting,
    opacitySetting,
    backgroundSetting,
    borderSetting,
    borderRadiusSetting,
    boxShadowSetting,
    sizeSetting,
    pageScrollSetting,
    imageScaleSetting,
    iconReplaceSetting,
    animateGroupSet
  },
  props: {
    option: { type: [Object, String], default: null },
    container_id: { type: Number, default: null },
    rect_id: { type: Number, default: null },
    onlyShowScrollAnimate:{type:Boolean, default:false}
  },
  data() {
    return {
      activeNames: ["1", "2", "3",'4'],
      showPageLoadAnimate: false,
      activePageLoadAnimateIndex: undefined,
      activeAnimateType: undefined,
      selectRectName: "",
      showRectTree: false,
      showChooseComponent: true,

      activeAnimateSetting: "",
      activeAnimate: undefined,
      responseRectIds: this.ids,
      innerElementLabel: [],

      showHoverAnimate: false,
      activeHoverAnimateIndex: undefined,

      showClickAnimate: false,
      activeClickAnimateIndex: undefined,
    }
  },
  watch:{
    'ids.rectId'(newVal){
      this.activeAnimateSetting = undefined
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    options() {
      let ids = idsFilter(this.ids)
      if (ids.uid && !ids.hasOwnProperty("elementInLayoutId")) {
        return this.option.componentBoxOptions
      } else if(ids.cellId && !isExist(ids.elementInDataGridId)){
        return this.option.options
      } else{
        return this.option
      }
    },
    animateGroup:{
      get(){
        if(!this.options.hasOwnProperty("animateGroup")){
          this.changeOptions("animateGroup", {}, this.ids,true)
        }
        return  this.options.animateGroup
      },
      set(newVal){
        this.changeOptions("animateGroup", newVal, this.ids)
      }
    },
    recoverClickAnimateStatu:{
      get(){
        if(!this.options.hasOwnProperty("recoverClickAnimateStatu")){
          return false
        }
        return this.options.recoverClickAnimateStatu
      },
      set(val){
        this.changeOptions( "recoverClickAnimateStatu",val,this.ids)
      }
    },
    //自由布局，轮播不添加整体的鼠标事件
    showMouseEvent() {
      let ids = idsFilter(this.ids)
      if (ids.uid && (!ids.hasOwnProperty("elementInLayoutId") || typeof ids.elementInLayoutId!== 'undefined')) {
        // 当前对象为单元格
        return true
      } else if(ids.cellId && !isExist(ids.elementInDataGridId)) {
        // 列表组件的单元格
        return true
      } else {
        let complexComponent = ["emptyLayoutComponent", "swiperComponent", "layoutComponent"]
        if (!this.option.innerElement) {
          return false
        }
        return complexComponent.indexOf("this.option.innerElement") > -1 ? false : true
      }
    },
    isOnlyNormalRect() {
      // 判断是否为普通组件（不是在自由布局或者轮播里的组件）
      // 页面滚动不出发复杂组件内部组件的 动画
      let ids = idsFilter(JSON.parse(JSON.stringify(this.ids)))
      delete ids.path
      delete ids.elementInAutoLayoutId
      delete ids.directionIndexOther
      let idsLen = objectSize(ids)
      return idsLen > 2 ? false : true
    },
    //页面加载 当前组件的动画
    pageloadAnimates: {
      get() {
        if (!this.options.hasOwnProperty("pageloadAnimates")) {
          this.changeOptions("pageloadAnimates", [], this.ids, true)
        }
        const pageloadAnimates = this.options.pageloadAnimates
        // for (let i = pageloadAnimates.length - 1; i >= 0; i--) {
        //   if(!compareIds(pageloadAnimates[i].controlIds, this.ids)) {
        //     pageloadAnimates.splice(i, 1)
        //   }
        // }
        return pageloadAnimates
      },
      set(newVal) {
        this.changeOptions("pageloadAnimates", newVal, this.ids)
      }
    },
    ownPageloadAnimates() {
      return this.findOwnAnimates(this.pageloadAnimates)
    },
    //鼠标悬浮到 当前组件的动画
    hoverAnimates: {
      get() {
        console.log("this.hoverAnimates",this.options)
        if (!this.options.hasOwnProperty("hoverAnimates")) {
          this.changeOptions("hoverAnimates", [], this.ids, true)
        }
        let hoverAnimates = this.options.hoverAnimates || []
        // for (let i = hoverAnimates.length - 1; i >= 0; i--) {
        //   if(!compareIds(hoverAnimates[i].controlIds, this.ids)) {
        //     hoverAnimates.splice(i, 1)
        //   }
        // }
        return hoverAnimates
      },
      set(newVal) {
        this.changeOptions("hoverAnimates", newVal, this.ids)
      }
    },
    ownHoverAnimates() {
      return this.findOwnAnimates(this.hoverAnimates)
    },
    // 鼠标点击动画
    clickAnimates: {
      get() {
        if (!this.options.hasOwnProperty("clickAnimates")) {
          this.changeOptions("clickAnimates", [], this.ids, true)
        }
        let clickAnimates = this.options.clickAnimates
        // for (let i = clickAnimates.length - 1; i >= 0; i--) {
        //   if(!compareIds(clickAnimates[i].controlIds, this.ids)) {
        //     clickAnimates.splice(i, 1)
        //   }
        // }
        return clickAnimates
      },
      set(newVal) {
        this.changeOptions("clickAnimates", newVal, this.ids)
      }
    },
    ownClickAnimates() {
      return this.findOwnAnimates(this.clickAnimates)
    }
  },
  mounted() {
    this.getComponetName()
  },
  methods: {
    getComponetName() {
      let ids = idsFilter(this.ids)
      if (ids.uid && !ids.hasOwnProperty("elementInLayoutId")) {
        // 当前对象为单元格
        this.selectRectName = "单元格"
      } else if(ids.cellId && !isExist(ids.elementInDataGridId)) {
        // 当前对象为单元格
        this.selectRectName = "单元格"
      } else {
        // const name = componentNames[this.options.innerElement]
        const name = componentNames[this.options.menuName]
        this.selectRectName = name ? name : this.options.menuName
      }
    },
    // 查找出由当前组件控制的动画
    findOwnAnimates(animates) {
      let ownAnimates = []
      animates?.forEach(item => {
        if (compareIds(item.controlIds, this.ids)) {
          ownAnimates.push(item)
        }
      })
      console.log("ownAnimates", ownAnimates)
      return ownAnimates
    },
    // 添加动画
    addAnimateBtn(type) {
      this[`show${type}Animate`] = true
    },
    // 给组件添加上动画
    addAnimate(animates, target, type) {
      this[`show${type}Animate`] = false
      let typeName = type.toLocaleLowerCase()
      const temp = simpleDeepClone(this[`${typeName}Animates`])
      temp.push({
        ...animates,
        componentName: this.selectRectName,
        ids: target, //动画对象的id
        controlIds: JSON.parse(JSON.stringify(this.ids)), //控制动画的对象
        passiveIds: [target], // 被控制动画的组件集合
        animateId: v1() // 动画的唯一Id
      })
      this[`${typeName}Animates`] = temp
    },
    showMoreHandles(index, type) {
      // this.activePageLoadAnimateIndex = index
      this[`active${type}AnimateIndex`] = index
    },
    animateItemLeave() {
      this.activePageLoadAnimateIndex = undefined
    },
    // 编辑动画参数
    editAnimate(animate, index, animateType) {
      this.activeAnimateIndex = index
      this.activeAnimate = JSON.parse(JSON.stringify(animate))
      this.activeAnimateSetting = `${animate.animateType}Setting`
      this.activeAnimateType = animateType
      // 触发页面滚动的时候 不显示被触发的对象
      this.showChooseComponent = this.activeAnimate.animateType === "pageScroll" ? false : true

      this.innerElementLabel = animate.componentName
      this.responseRectIds = animate.passiveIds

      this[`active${animateType}AnimateIndex`] = undefined
    },
    // 复制动画
    copyAnimate(animate, index, type) {
      let newAnimate = JSON.parse(JSON.stringify(animate))
      newAnimate.animateId = v1()
      let animateType = type.toLocaleLowerCase()
      let tempIndex = animate.passiveIds.findIndex(ids=>compareIds(ids,animate.controlIds))
      if(tempIndex === -1){
        this[`${animateType}Animates`].splice(index, 0, newAnimate)
      }
      this.editPassiveIdsAnimate(newAnimate, "add", type)
    },
    // 删除动画
    delAnimate(index, type) {
      let _this = this
      this.$confirm("删除后无法恢复，确认删除？", "", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "<p>删除后无法恢复，确认删除？</p>",
        iconClass: "bigScreen_confirm_icon el-icon-warning",
        cancelButtonClass: "bigScreen_confirm_cancel_button",
        confirmButtonClass: "bigScreen_confirm_button",
        customClass: "bigScreen_confirm custom_warning_dialog"
      })
          .then(() => {
            let animateType = type.toLocaleLowerCase()
            // 删除自身动画 + 被控制组件的动画
            _this.activeAnimateIndex = index
            _this.activeAnimate = _this[`${animateType}Animates`][index]
            // _this[`${animateType}Animates`].splice(index, 1)
            let temp = _this[`${animateType}Animates`]
            temp.splice(index, 1)
            _this[`${animateType}Animates`] = temp
            _this.editPassiveIdsAnimate(_this.activeAnimate, "del", animateType)
          })
          .catch(err => {})
    },
    // 保存动画设置
    saveAnimateSet() {
      if (this.responseRectIds.length === 0) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "动画对象不能为空哦!",
          type: "error"
        })
        return
      }
      console.log("saveAnimateSet",this.activeAnimate)
      if (this.activeAnimate.animateType === "pageScroll") {
        this.responseRectIds = this.activeAnimate.passiveIds
      }
      this.activeAnimateSetting = undefined
      let oldPassiveIds = JSON.parse(JSON.stringify(this.activeAnimate.passiveIds))
      let animateType = this.activeAnimateType.toLocaleLowerCase()
      let animateId = this.activeAnimate.animateId

      oldPassiveIds.forEach(ids => {
        // 如果不存在 则删除该组件中的动画
        let isExist = false
        for (let i = 0; i < this.responseRectIds.length; i++) {
          if (compareIds(ids, this.responseRectIds[i])) {
            isExist = true
            break
          }
        }
        if (!isExist) {
          let selectedOptions
          if (ids.uid && !ids.hasOwnProperty("elementInLayoutId")) {
            selectedOptions = this.activeCol(ids)
          } else {
            selectedOptions = this.$getOptions(ids)
          }
          let animates = selectedOptions[`${animateType}Animates`]
          let animateIndex = animates?.findIndex(animateItem => animateItem.animateId === animateId) || -1
          if (animateIndex > -1 && !compareIds(ids, this.activeAnimate.controlIds)) {
            animates.splice(animateIndex, 1)
          }
        }
      })
      let newAnimate = {
        ...this.activeAnimate,
        componentName: !this.showChooseComponent? this.activeAnimate.componentName:this.innerElementLabel,
        passiveIds: this.responseRectIds || [this.activeAnimate.ids]
      }
      let temp = simpleDeepClone(this[`${animateType}Animates`])
      temp.splice(this.activeAnimateIndex, 1, newAnimate)
      this[`${animateType}Animates`] = temp
      this.editPassiveIdsAnimate(newAnimate, "edit", animateType)
      this.cancleAnimateSet()
    },
    // 取消动画设置
    cancleAnimateSet() {
      this.activeAnimateSetting = undefined
      this.activeAnimateType = undefined
      this.showRectTree = false
    },
    // 修改被动组件的动画
    editPassiveIdsAnimate(animate, type, animatetype) {
      let animateType = animatetype.toLocaleLowerCase()
      animate.passiveIds?.forEach(item => {
        let isCurrentIds = compareIds(this.ids, item)
        let curAnimate = {
          ...animate,
          ids: item
        }
        let isCol = false,isDataGridCell=false //是否为单元格
        if (type === 'del' && isCurrentIds) {
          //  删除的是自身控制的动画，则不需要再做处理
          return
        }
        let selectedOptions
        if (item.uid && !item.hasOwnProperty("elementInLayoutId")) {
          isCol = true
          selectedOptions = this.activeCol(item)
        } else if(item.cellId && !isExist(item.elementInDataGridId)) {
          isDataGridCell = true
          selectedOptions = this.activeDataGridCol(item)
        } else {
          selectedOptions = this.$getOptions(item)
        }
        let animates = selectedOptions[`${animateType}Animates`]
        if (!animates || animates.length === 0) {
          animates = [curAnimate]
          this.changeOptions(`${animateType}Animates`, animates, item)
          return
        }
        let animateIndex = -1
        switch (type) {
          case "del":
            animateIndex = animates.findIndex(animateItem => animateItem.animateId === animate.animateId)
            if (animateIndex > -1) {
              animates.splice(animateIndex, 1)
            }
            break
          case "add":
            animates.push(curAnimate)
            break
          case "edit":
            animateIndex = animates.findIndex(animateItem => animateItem.animateId === animate.animateId)
            if (animateIndex > -1) {
              animates.splice(animateIndex, 1, curAnimate)
            } else {
              animates.push(curAnimate)
            }
            break
          default:
        }
        if (isCol) {
          const param = {
            ...item,
            option_val: animates,
            option_name: `${animateType}Animates`
          }
          this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
        } else if(isDataGridCell) {
          const param = {
            ...item,
            option_val: animates,
            option_name: `${animateType}Animates`
          }
          this.$store.dispatch(this.request_prefix + "/changeDataGridOptions", param)
        } else {
          this.changeOptions(`${animateType}Animates`, animates, item)
        }
      })
    },
    activeCol(ids) {
      let rectAttr = this.getRectAttribute.call(this, ids).options
      if (ids.elementInAutoLayoutId !== undefined) {
        rectAttr = this.getAttrById(this.$store.state[this.request_prefix], ids, "elementInAutoLayout")
      }
      const useActiveIndex = rectAttr.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.activeIndex
      const pOptions = [rectAttr.rows[useActiveIndex]]
      return handleFindLayoutComponentOptionsCols(pOptions, ids.uid).componentBoxOptions
    },
    activeDataGridCol(ids){
      return this.getAttrById(this.$store.state[this.request_prefix], ids, "dataGridCell")?.options
    },
    changeOptions(key, val, ids, isGetter) {
      if (ids.uid && !ids.hasOwnProperty("elementInLayoutId")) {
        // 当前只是单元格
        const param = {
          ...ids,
          option_val: val,
          option_name: "componentBoxOptions-" + key
        }
        this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
      } else{
        this.$changeOptionsEV(val, key, false, "", ids, !!isGetter)
      }
    },
    // 快捷添加动画
    addDefaultAnimate(type, animateType) {
      // 添加已经列出来的默认动画
      let animates
      switch (type) {
        case "pageload":
          animates = this.animateStyles
          break
        case "hover":
          animates = this.hoverAnimateStyles
          break
        case "click":
          animates = this.clickAnimateStyles
      }
      let newAnimate
      for (let i = 0; i < animates.length; i++) {
        newAnimate = animates[i].list.find(item => item.animateType === animateType)
        if (newAnimate) {
          break
        }
      }
      // delete newAnimate.iconClass
      let curIds = JSON.parse(JSON.stringify(this.ids))
      const temp = simpleDeepClone(this[`${type}Animates`])
      temp.push({
        ...newAnimate,
        componentName: this.selectRectName,
        ids: curIds, //动画对象
        controlIds: curIds, //控制动画的对象
        passiveIds: [curIds], // 被控制动画的组件集合
        animateId: v1() // 动画的唯一Id
      })
      this[`${type}Animates`] = temp
    },
    // 预览动画
    scanAnimates(type) {
      let currentDomClass, animateDom, animateDomArr
      let ids = idsFilter(this.ids)
      if(ids.cellId){
        // 新的列表数据组件中的子组件
        if(ids.elementInDataGridId){
          currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}-cell_id_${ids.cellId}-elementInDataGridId_${ids.elementInDataGridId}`
        }else{
          currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}-cell_id_${ids.cellId}`
        }
        animateDom = document.getElementsByClassName(currentDomClass)[0]
        animateDomArr =[animateDom]
      } else if (ids.uid && !ids.hasOwnProperty("elementInLayoutId")) {
        // 单元格
        currentDomClass = `componentBox_after${ids.uid}`
        animateDom = document.getElementById(currentDomClass)
        animateDomArr =[animateDom]
      } else if (ids.hasOwnProperty("directionIndex")) {
        // 边栏内组件
        currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}`
        // currentDomClass = ids.hasOwnProperty("uid") ? currentDomClass + `-uid_${ids.uid}` : currentDomClass
        currentDomClass = ids.hasOwnProperty("directionIndex")
            ? currentDomClass + `-directionIndex_${ids.directionIndex}` + `-elementInLayoutId_${ids.elementInLayoutId}`
            : currentDomClass
        animateDom = document.getElementsByClassName(currentDomClass)[0]
        animateDomArr =[animateDom]

        // animateDom = animateDom ? animateDom.getElementsByClassName("rect")[0] : null
      } else if (ids.hasOwnProperty("elementInAutoLayoutId")) {
        // 自动布局中的组件
        let tempRect = this.getAttrById(this.$store.state[this.request_prefix], ids, "rect").options
        if (ids.uid) {
          if (tempRect.innerElement === "cxAutoLayout") {// 自由布局在自动布局中
            if (ids.hasOwnProperty("elementInLayoutId")) {
              currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}-uid_${ids.uid}-elementInLayoutId_${ids.elementInLayoutId}` 
            }
          } else {// 自动布局在自由布局中
            currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}-uid_${ids.uid}-elementInLayoutId_${ids.elementInLayoutId}-elementInAutoLayoutId_${ids.elementInAutoLayoutId}-path_${ids.path ? ids.path.join('') : ids.path}`
          }
        } else {
          currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}-elementInAutoLayoutId_${ids.elementInAutoLayoutId}-path_${ids.path ? ids.path.join('') : ids.path}`
        }
        animateDom = document.getElementsByClassName(currentDomClass)[0]
        animateDomArr =[animateDom]
      } else if (ids.hasOwnProperty("elementInLayoutId")) {
        // 单元格内组件
        currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}`
        currentDomClass = ids.hasOwnProperty("uid") ? currentDomClass + `-uid_${ids.uid}` : currentDomClass
        currentDomClass = ids.hasOwnProperty("elementInLayoutId")
            ? currentDomClass + `-elementInLayoutId_${ids.elementInLayoutId}`
            : currentDomClass
        animateDom = document.getElementsByClassName(currentDomClass)[0]
        animateDomArr =[animateDom]
      } else if (ids.hasOwnProperty("elementInSwiperId")) {
        // 轮播内组件  轮播组件因为涉及复制 所以存在多个
        animateDom = document.getElementsByClassName( `container_id_${ids.container_id}-rect_id_${ids.rect_id}-swiperContent_id_${ids.swiperContent_id}-elementInSwiperId_${ids.elementInSwiperId}`)
        animateDomArr =animateDom
      } else{
        currentDomClass = `container_id_${ids.container_id}-rect_id_${ids.rect_id}`
        animateDom = document.getElementsByClassName(currentDomClass)[0]
        animateDomArr =[animateDom]
      }
      if (animateDomArr.length === 0) {
        return
      }
      // animateDom = animateDom.parentNode
      let event = new CustomEvent("scan", {
        detail: {
          _ids: this.ids
        }
      })
      let pageScan = new CustomEvent("pageScan", {
        detail: {
          _ids: this.ids
        }
      })
      let pageScan1 = new CustomEvent("pageScan1", {
        detail: {
          _ids: this.ids
        }
      })
      let clickScan = new CustomEvent("clickScan",{
        detail: {
          _ids: this.ids
        }
      })
      // animateDom = Array.isArray(animateDom)?animateDom:[animateDom]
      for(let i=0;i<animateDomArr.length;i++){
        let item= animateDomArr[i]
        switch (type) {
          case "pageload":
            item.dispatchEvent(pageScan)
            break
          case "pageload1":
            item.dispatchEvent(pageScan1)
            break
          case "hover":
            item.dispatchEvent(event)
            break
          case "click":
            item.dispatchEvent(clickScan)
            break
          default:
        }
      }
    },
    closeAnimateList(e) {
      // 滑动滚动条 不触发关闭
      for (let i = 0; i < e.target.classList.length; i++) {
        if (e.target.classList[i].indexOf("el-scrollbar") > -1) {
          return
        }
      }
      this.showClickAnimate = false
      this.showHoverAnimate = false
      this.showPageLoadAnimate = false
      this.showRectTree = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-collapse {
  position: relative;
}
::v-deep .animates-items {
  padding: 16px;
  box-sizing: border-box;
  &:not(:last-child) {
    border-bottom: 1px solid #e9e9e9;
  }
}
.add-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 24px;
  text-align: center;
  height: 24px;
  line-height: 24px;
  .icon {
    font-size: 13px;
    color: var(--themeColor);
  }
}
.animates-lists {
  position: absolute;
  width: 260px;
  right: 0;
  top: 38px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  box-shadow: 0 6px 24px rgba(31, 35, 41, 0.1);
  border-radius: 4px;
  z-index: 100;
}
.own-animates {
  position: relative;
  padding-left: 20px;
  box-sizing: border-box;
  &:before {
    position: absolute;
    content: "";
    left: 10px;
    top: 0;
    height: 100%;
    width: 1px;
    background-color: rgba(201, 201, 201, 1);
  }
}
.own-animate-item {
  position: relative;
  background: #f3f3f3;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  line-height: 32px;
  height: 32px;
  margin-bottom: 12px;
  padding: 0 8px;
  box-sizing: border-box;
  z-index: 1;
  .animate-item{
    cursor: pointer;
  }
  &:before {
    position: absolute;
    content: "";
    left: -16px;
    top: 10px;
    background-color: #c9c9c9;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 3px solid #fff;
  }
  .more-handles {
    display: none;
    cursor: pointer;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    color: rgba(0, 0, 0, 0.4);
    margin-left: 4px;
    &:hover {
      background: #f0f0f0;
    }
  }
  &:hover {
    border: 1px solid #9cc2ff;
    background: #e8f2ff;
    z-index: 2;
    .more-handles {
      display: inline-block;
    }
  }
  .handle-btns {
    //display: none;
    position: absolute;
    right: 0;
    top: 32px;
    background: #ffffff;
    border: 1px solid #f0f0f0;
    box-shadow: 0 6px 24px rgba(31, 35, 41, 0.1);
    border-radius: 4px;
    z-index: 10;
  }
  .handle-btn-item {
    line-height: 38px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);
    width: 80px;
    padding-left: 12px;
    box-sizing: border-box;
    cursor: pointer;
    .icon {
      display: inline-block;
      margin-right: 8px;
      font-size: 14px;
    }
  }
}
.animate-Setting-header {
  padding: 8px 16px;
  height: 44px;
  background: #f0f0f0;
  color: rgba(0, 0, 0, 0.8);
  .animete-name {
    font-weight: 600;
  }
  button {
    width: 50px;
    height: 28px;
    text-align: center;
    margin-left: 12px;
    border-radius: 4px;
    font-size: 13px;
  }
  .cancle-btn {
    background-color: transparent;
    border: 1px solid rgba(0, 0, 0, 0.14);
  }
  .primary-btn {
    background-color: var(--themeColor);
    border: 1px solid var(--themeColor);
    color: #fff;
    &:hover {
      background: var(--primaryButtonHover);
    }
  }
}
.animate-target {
  padding: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #e9e9e9;
}
.selected-rect {
  padding: 0 12px;
  background: #f3f3f3;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.8);
  line-height: 32px;
  width: 100%;
  cursor: pointer;
  box-sizing: border-box;
}
.rectTreeWrap {
  position: relative;
  &.zIndex9999{
    z-index: 9999;
  }
  .rectTree {
    position: absolute;
    top: 32px;
    left: 0;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 6px 24px rgba(31, 35, 41, 0.1);
    padding: 8px;
    box-sizing: border-box;
    z-index: 2;
  }
}
.rect-tree-inp {
  position: relative;
  .icon-portal-arrows-down {
    position: absolute;
    right: 8px;
    top: 8px;
    font-size: 16px;
    pointer-events: none;
    cursor: pointer;
    transition: all 0.5s;
  }
  .rotate180 {
    transform: rotate(180deg);
  }
}
/*空动态样式*/
.empty-animate {
  text-align: center;
  color: rgba(0, 0, 0, 0.4);
  font-size: 12px;
  padding: 12px 0;
  .icon {
    font-size: 30px;
    margin-bottom: 14px;
  }
  p {
    margin-bottom: 8px;
    line-height: 16px;
  }
  button {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.14);
    border-radius: 4px;
    line-height: 28px;
    color: rgba(0, 0, 0, 0.4);
    background-color: transparent;
    margin-top: 8px;
  }
}
.scan-btn {
  width: 100%;
  border: 1px solid #2b67ff;
  border-radius: 4px;
  line-height: 32px;
  background-color: transparent;
  color: #2b67ff;
  margin: 8px 0;
  cursor: pointer;
  .icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 6px;
  }
  &:active {
    background-color: var(--defaultButtonHover);
  }
}
.animate-name{
  margin-right: 8px;
}
.component-name{
  flex:1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.animate-setting-main{
  height: calc(100% - 50px);
  overflow: auto;
  padding-right: 15px;
  box-sizing: border-box;
  width: calc(100% + 15px);
}
.height100{
  height: 100%;
}
</style>
